if (!customElements.get('atelier-sticky-buy')) {
  customElements.define('atelier-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = document.querySelector('product-info[id^="MainProduct-"]');
      if (!this.productInfo) return;
      this.button = this.querySelector('button');
      this.price = this.querySelector('[data-sticky-price]');
      this.onClick = () => {
        const primary = this.productInfo.querySelector('product-form button[type="submit"]');
        if (!primary || primary.disabled || primary.getAttribute('aria-disabled') === 'true') return;
        primary.form.requestSubmit(primary);
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.productInfo, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
      const setBuilder = this.setBuilder = document.getElementById('ValeaSetBuilder');
      if (setBuilder) {
        this.setIntersection = new IntersectionObserver(([entry]) => {
          this.setInView = entry.isIntersecting;
          this.updateVisibility();
        });
        this.setIntersection.observe(setBuilder);
      }
      this.sync();
      this.onScroll = () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          this.pastPrimary = Boolean(this.primary && this.primary.getBoundingClientRect().bottom < 0);
          const bounds = this.setBuilder?.getBoundingClientRect();
          this.setInView = Boolean(bounds && bounds.top < window.innerHeight && bounds.bottom > 0);
          this.updateVisibility();
        });
      };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
    }
    sync() {
      const primary = this.productInfo.querySelector('product-form button[type="submit"]');
      this.button.disabled = !primary || primary.disabled || primary.getAttribute('aria-disabled') === 'true';
      this.button.textContent = primary?.querySelector('span')?.textContent.trim() || window.variantStrings.unavailable;
      const price = this.productInfo.querySelector('.price__sale .price-item--sale');
      const regular = this.productInfo.querySelector('.price__regular .price-item--regular');
      const priceBox = this.productInfo.querySelector('.price');
      this.price.textContent = (priceBox?.classList.contains('price--on-sale') ? price : regular)?.textContent.trim() || '';
      if (primary !== this.primary) {
        this.intersection?.disconnect();
        this.primary = primary;
        if (primary) {
          this.intersection = new IntersectionObserver(([entry]) => {
            this.pastPrimary = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.updateVisibility();
          });
          this.intersection.observe(primary);
        }
      }
    }
    updateVisibility() {
      this.classList.toggle('is-visible', Boolean(this.pastPrimary) && !this.setInView);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.setIntersection?.disconnect();
      cancelAnimationFrame(this.scrollFrame);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
